import api from './api';
// 根据类型Id获取模块列表
export function getModuleListByTypeId(params) {
  return api.post('common/listcom', params, false, false).then(res => res);
}
// 新增模块信息
export function addModule(params) {
  return api.post('/common/save.html', params, false, false).then(res => res);
}
// 删除模块信息
export function deleteModule(params) {
  return api.post('/common/delet.html', params, false, false).then(res => res);
}
// 修改模块信息
export function updateModule(params) {
  return api.post('/common/update.html', params, false, false).then(res => res);
}



// WEBPACK FOOTER //
// ./src/api/module.js